import { InputGroupText as _InputGroupText, InputGroupTextProps as _InputGroupTextProps } from "reactstrap";

    export const InputGroupText = _InputGroupText;
    export type InputGroupTextProps = _InputGroupTextProps;
    